import { resolveLobbyReturnUrl, safeLobbyReturnUrl } from '@low6-pickem/frontend-shared';

export const SQUARES_FROM_LOBBY_KEY = 'squares_from_lobby';
export const SQUARES_LOBBY_URL_KEY = 'squares_lobby_return_url';

/** True when this session arrived from the external Lobby (query or session). */
export function isFromLobby(searchParams: URLSearchParams): boolean {
  return (
    searchParams.get('from') === 'lobby' || sessionStorage.getItem(SQUARES_FROM_LOBBY_KEY) === '1'
  );
}

/**
 * Append lobby deep-link params so internal navigations keep "Back to Lobby" working
 * (including completed games opened from Recent / My Games).
 */
export function appendLobbyParams(path: string, searchParams: URLSearchParams): string {
  if (!isFromLobby(searchParams)) return path;

  const [pathname, existingQuery = ''] = path.split('?');
  const params = new URLSearchParams(existingQuery);
  params.set('from', 'lobby');

  const lobbyReturn =
    searchParams.get('lobbyReturn') || sessionStorage.getItem(SQUARES_LOBBY_URL_KEY);
  if (lobbyReturn) params.set('lobbyReturn', lobbyReturn);

  const token = searchParams.get('token');
  if (token) params.set('token', token);

  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

/** Full-page navigate to the lobby return URL (same behavior as Pick'em / Daily Reveal). */
export function navigateToLobby(searchParams: URLSearchParams): void {
  sessionStorage.removeItem(SQUARES_FROM_LOBBY_KEY);
  const url =
    sessionStorage.getItem(SQUARES_LOBBY_URL_KEY) ??
    resolveLobbyReturnUrl(searchParams, SQUARES_LOBBY_URL_KEY);
  sessionStorage.removeItem(SQUARES_LOBBY_URL_KEY);
  window.location.href = safeLobbyReturnUrl(url);
}
